/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Notification } from '../../utils/utils';
import { createAction } from '../../utils/redux-utils';

export enum NotificationActions {
    SET_NOTIFICATION = 'SET NOTIFICATION',
    HIDE_NOTIFICATION = 'HIDE NOTIFICATION',
    HIDE_ALL_NOTIFICATIONS = 'HIDE ALL NOTIFICATIONS',
}

export const setNotificationAction = (notification: Notification) =>
    createAction(NotificationActions.SET_NOTIFICATION, { notification });

export const hideNotificationAction = (index?: number) => createAction(NotificationActions.HIDE_NOTIFICATION, index);

export const hideAllNotificationsAction = () => createAction(NotificationActions.HIDE_ALL_NOTIFICATIONS);

export type NotificationAction = ReturnType<typeof setNotificationAction> | ReturnType<typeof hideNotificationAction>;
